var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-wrapper"},[_c('div',{staticClass:"content-box"},[_c('avatar-dropdown',{staticClass:"action",attrs:{"menu":true,"current-user":_vm.currentUser}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }